export const phoneNumbers = {
  hotline: "400-600-7040",
  landline: "158 9529 2999",
  mobile: "158 9529 2999"
};

export const navGroups = [
  { label: { "zh-CN": "首页", "en-US": "Home" }, path: "/" },
  {
    label: { "zh-CN": "关于宏邦", "en-US": "About" },
    path: "/about",
    children: [
      { label: { "zh-CN": "公司介绍", "en-US": "Company Profile" }, path: "/about" },
      { label: { "zh-CN": "发展历程", "en-US": "History" }, path: "/about/history" }
    ]
  },
  {
    label: { "zh-CN": "产品中心", "en-US": "Products" },
    path: "/products",
    children: [
      { label: { "zh-CN": "油浸式变压器", "en-US": "Oil-Immersed Transformers" }, path: "/products/oil-immersed" },
      { label: { "zh-CN": "干式变压器", "en-US": "Dry-Type Transformers" }, path: "/products/dry-type" },
      { label: { "zh-CN": "35kV电力变压器", "en-US": "35kV Power Transformers" }, path: "/products/220kv" },
      { label: { "zh-CN": "箱式变电站", "en-US": "Prefabricated Substations" }, path: "/products/110kv" },
      { label: { "zh-CN": "高低压成套设备", "en-US": "High and Low Voltage Complete Sets" }, path: "/products/500kv" }
    ]
  },
  {
    label: { "zh-CN": "新闻动态", "en-US": "News" },
    path: "/news",
    children: [
      { label: { "zh-CN": "行业资讯", "en-US": "Industry News" }, path: "/news/industry" },
      { label: { "zh-CN": "本站动态", "en-US": "Company News" }, path: "/news/company" }
    ]
  },
  {
    label: { "zh-CN": "荣誉资质", "en-US": "Honors" },
    path: "/honors"
  },
  { label: { "zh-CN": "企业风貌", "en-US": "Gallery" }, path: "/gallery" },
  { label: { "zh-CN": "工程案例", "en-US": "Cases" }, path: "/cases" },
  {
    label: { "zh-CN": "联系我们", "en-US": "Contact" },
    path: "/contact"
  }
];

export const heroSlides = [
  {
    title: {
      "zh-CN": "江苏宏邦，整体配电解决方案专家",
      "en-US": "Jiangsu Hongbang, a specialist in integrated power distribution solutions"
    },
    subtitle: {
      "zh-CN": "变压器 · 成套设备 · 箱式变电站   一站式配齐",
      "en-US": "Transformers, complete sets of equipment, and prefabricated substations – all in one place."
    },
    tag: "SMART POWER",
    cta: { "zh-CN": "查看更多", "en-US": "Learn More" },
    imageClass: "hero-image-one",
    imageUrl: "/hero/home-banner-01.jpg",
    visualImageUrl: "/page/cahngqutp.jpg"
  },
  {
    title: {
      "zh-CN": "不止于设备，更落地方案",
      "en-US": "More than just equipment, it's about implementation solutions."
    },
    subtitle: {
      "zh-CN": "从变压器到成套系统，为配电工程全力护航。",
      "en-US": "From transformers to complete systems, providing full support for power distribution projects."
    },
    tag: "LOW CARBON",
    cta: { "zh-CN": "查看方案", "en-US": "View Solutions" },
    imageClass: "hero-image-two",
    imageUrl: "/hero/home-banner-02.jpg",
    visualImageUrl: "/page/zhanshitu.jpg"
  }
];

export const productCategories = [
  { label: { "zh-CN": "油浸式变压器", "en-US": "Oil-Immersed Transformers" }, path: "/products/oil-immersed" },
  { label: { "zh-CN": "干式变压器", "en-US": "Dry-Type Transformers" }, path: "/products/dry-type" },
  { label: { "zh-CN": "35kV电力变压器", "en-US": "35kV Power Transformers" }, path: "/products/220kv" },
  { label: { "zh-CN": "箱式变电站", "en-US": "Prefabricated Substations" }, path: "/products/110kv" },
  { label: { "zh-CN": "高低压成套设备", "en-US": "High and Low Voltage Complete Sets" }, path: "/products/500kv" }
];

export const featuredProducts = [
  {
    title: { "zh-CN": "油浸式变压器", "en-US": "Oil-Immersed Transformers" },
    path: "/products/oil-immersed",
    summary: {
      "zh-CN": "覆盖S11、S13、S20、S22等系列，适配工业配电与工程项目。",
      "en-US": "Covering S11, S13, S20 and S22 series for industrial distribution and engineering projects."
    }
  },
  {
    title: { "zh-CN": "干式变压器", "en-US": "Dry-Type Transformers" },
    path: "/products/dry-type",
    summary: {
      "zh-CN": "适用于商业建筑、公共设施、工业厂区等室内配电场景。",
      "en-US": "Suitable for indoor distribution in commercial buildings, public facilities and industrial sites."
    }
  },
  {
    title: { "zh-CN": "35kV电力变压器", "en-US": "35kV Power Transformers" },
    path: "/products/220kv",
    summary: {
      "zh-CN": "服务工业园区、区域配网、新能源升压及工程配套项目。",
      "en-US": "Serving industrial parks, regional grids, renewable booster stations and engineering projects."
    }
  },
  {
    title: { "zh-CN": "箱式变电站", "en-US": "Prefabricated Substations" },
    path: "/products/110kv",
    summary: {
      "zh-CN": "提供欧变、美变及工程预装式变电站整体解决方案。",
      "en-US": "Providing European, American and pre-installed substation solutions."
    }
  },
  {
    title: { "zh-CN": "高低压成套设备", "en-US": "High and Low Voltage Complete Sets" },
    path: "/products/500kv",
    summary: {
      "zh-CN": "配套高低压开关柜、配电箱、电抗器、消弧线圈等设备。",
      "en-US": "Supporting switchgear, distribution boxes, reactors, arc suppression coils and related equipment."
    }
  }
];

export const companyStats = [
  {
    value: "30",
    unit: { "zh-CN": "年", "en-US": "Y" },
    label: { "zh-CN": "行业生产经验", "en-US": "Years of Experience" }
  },
  {
    value: "900",
    unit: "+",
    label: { "zh-CN": "占地面积900多亩", "en-US": "900+ Mu of Land Area" }
  },
  {
    value: "50",
    unit: "+",
    label: { "zh-CN": "年销售金额达50亿元", "en-US": "5 Billion RMB Annual Sales" }
  },
  {
    value: "2000",
    unit: "+",
    label: { "zh-CN": "集团现有2000名员工", "en-US": "2000+ Employees" }
  }
];

export const solutions = [
  {
    title: { "zh-CN": "通信行业解决方案", "en-US": "Telecom Industry Solutions" },
    description: {
      "zh-CN": "为照明、电信基站、通信网络等场景提供定制的变压器解决方案。",
      "en-US": "Tailored transformer solutions for lighting, telecom base stations and communication networks."
    }
  },
  {
    title: { "zh-CN": "电力行业解决方案", "en-US": "Power Industry Solutions" },
    description: {
      "zh-CN": "覆盖变电站变压器、配电变压器等关键设备，确保电力供应稳定可靠。",
      "en-US": "Covering substations and distribution transformers for stable and reliable power supply."
    }
  },
  {
    title: { "zh-CN": "交通运输行业解决方案", "en-US": "Transportation Solutions" },
    description: {
      "zh-CN": "支持充电桩、铁路电力系统及交通基础设施等应用场景。",
      "en-US": "Supporting EV chargers, railway power systems and transport infrastructure."
    }
  },
  {
    title: { "zh-CN": "医疗行业解决方案", "en-US": "Healthcare Solutions" },
    description: {
      "zh-CN": "适配医院设备、医疗器械等高稳定性供电需求。",
      "en-US": "Designed for hospitals and medical equipment requiring highly stable power."
    }
  }
];

export const newsTabs = {
  industry: [
    {
      "zh-CN": "500kV变压器常用于什么地方",
      "en-US": "Where are 500kV transformers commonly used?"
    },
    {
      "zh-CN": "330kV~400kV 是否属于超高压",
      "en-US": "Do 330kV~400kV transformers belong to EHV?"
    },
    {
      "zh-CN": "干式变压器工作条件和要求",
      "en-US": "Operating conditions and requirements for dry-type transformers"
    },
    {
      "zh-CN": "油浸式变压器部件详细介绍",
      "en-US": "Detailed introduction to oil-immersed transformer components"
    }
  ],
  company: [
    {
      "zh-CN": "变压器出海及智能制造技术大会参展动态",
      "en-US": "Exhibition update on transformer export and intelligent manufacturing"
    },
    {
      "zh-CN": "3000kVA美式箱式变压器顺利发货",
      "en-US": "3000kVA American box-type transformer shipped successfully"
    },
    {
      "zh-CN": "出口美国首台69kV主变项目纪实",
      "en-US": "First 69kV main transformer project exported to the United States"
    },
    {
      "zh-CN": "加拿大太阳能及储能展会现场",
      "en-US": "On-site at the Canada Solar and Energy Storage Expo"
    }
  ]
};

export const footerLinks = [
  { label: { "zh-CN": "关于宏邦", "en-US": "About" }, path: "/about" },
  { label: { "zh-CN": "产品中心", "en-US": "Products" }, path: "/products" },
  { label: { "zh-CN": "新闻动态", "en-US": "News" }, path: "/news" },
  { label: { "zh-CN": "荣誉资质", "en-US": "Honors" }, path: "/honors" },
  { label: { "zh-CN": "企业风貌", "en-US": "Gallery" }, path: "/gallery" },
  { label: { "zh-CN": "工程案例", "en-US": "Cases" }, path: "/cases" },
  { label: { "zh-CN": "联系我们", "en-US": "Contact" }, path: "/contact" }
];

export const productPageMap = {
  "/products/oil-immersed": {
    title: { "zh-CN": "油浸式变压器", "en-US": "Oil-Immersed Transformers" },
    intro: {
      "zh-CN": "覆盖S11、S13、S15、S20、S22等油浸式变压器系列，适用于工业配电、园区供电、工程项目及各类稳定供电场景。",
      "en-US": "Covering S11, S13, S15, S20 and S22 oil-immersed transformer series for industrial distribution, park power supply and engineering projects."
    },
    galleryText: {
      "zh-CN": "油浸式系列适合容量跨度大、连续运行要求高的配电场景，可按项目需求配置节能型、非晶合金及立体卷铁芯等方案。",
      "en-US": "Oil-immersed series fit high-continuity distribution scenarios and can be configured for energy-saving, amorphous alloy and wound-core solutions."
    },
    images: [],
    cards: [
      {
        title: { "zh-CN": "低损耗高效率", "en-US": "Low Loss and High Efficiency" },
        description: { "zh-CN": "优化铁芯与绕组结构，降低空载和负载损耗，适合长期连续运行的配电系统。", "en-US": "Optimized core and winding design reduces no-load and load losses for continuous distribution operation." }
      },
      {
        title: { "zh-CN": "散热与绝缘稳定", "en-US": "Stable Cooling and Insulation" },
        description: { "zh-CN": "以变压器油承担绝缘与散热作用，提升运行热稳定性和复杂工况适应性。", "en-US": "Transformer oil provides insulation and cooling, improving thermal stability in demanding conditions." }
      },
      {
        title: { "zh-CN": "工程适配范围广", "en-US": "Broad Project Adaptability" },
        description: { "zh-CN": "可覆盖工厂、园区、配网、箱变配套等多类场景，便于按容量和能效等级选型。", "en-US": "Suitable for factories, parks, distribution grids and substations with flexible capacity and efficiency options." }
      }
    ]
  },
  "/products/dry-type": {
    title: { "zh-CN": "干式变压器", "en-US": "Dry-Type Transformers" },
    intro: {
      "zh-CN": "提供SCB、SGB等干式变压器产品，具备安全、环保、低噪音、维护便捷等特点，适配室内配电和公共建筑场景。",
      "en-US": "Providing SCB and SGB dry-type transformers with safe, environmentally friendly, low-noise and easy-maintenance characteristics for indoor distribution and public buildings."
    },
    galleryText: {
      "zh-CN": "干式系列不使用绝缘油，适合对防火、环保、维护便利性要求更高的室内配电与公共建筑场景。",
      "en-US": "Dry-type series use no insulating oil and suit indoor distribution scenarios requiring fire safety, environmental performance and easy maintenance."
    },
    images: [],
    cards: [
      {
        title: { "zh-CN": "阻燃安全", "en-US": "Fire-Safe Design" },
        description: { "zh-CN": "无油化结构降低泄漏和燃烧风险，适合商场、医院、轨交、数据中心等敏感场所。", "en-US": "Oil-free construction reduces leakage and fire risks for malls, hospitals, rail transit and data centers." }
      },
      {
        title: { "zh-CN": "低噪音低维护", "en-US": "Low Noise and Low Maintenance" },
        description: { "zh-CN": "浇注或非包封结构运行稳定，日常维护量小，便于室内长期部署。", "en-US": "Cast-resin or non-encapsulated construction supports stable operation with low routine maintenance." }
      },
      {
        title: { "zh-CN": "环境适应性强", "en-US": "Strong Environmental Adaptability" },
        description: { "zh-CN": "适用于潮湿、粉尘、负荷波动等复杂环境，可根据场景配置防护外壳。", "en-US": "Adaptable to humidity, dust and load variation, with enclosures configurable by site conditions." }
      }
    ]
  },
  "/products/220kv": {
    title: { "zh-CN": "35kV电力变压器", "en-US": "35kV Power Transformers" },
    intro: {
      "zh-CN": "面向35kV电力系统应用，服务工业园区、区域配网、新能源升压站及工程配套项目。",
      "en-US": "Designed for 35kV power systems, serving industrial parks, regional distribution grids, renewable booster stations and engineering projects."
    },
    galleryText: {
      "zh-CN": "35kV电力变压器面向中压配电和升压场景，强调低损耗、抗短路能力、绝缘可靠性和长期运行稳定性。",
      "en-US": "35kV power transformers serve medium-voltage distribution and step-up scenarios with low loss, short-circuit strength, insulation reliability and stable operation."
    },
    images: [],
    cards: [
      {
        title: { "zh-CN": "中压系统适配", "en-US": "Medium-Voltage System Fit" },
        description: { "zh-CN": "面向35kV配网、工业园区和新能源升压系统，满足项目侧稳定供电需求。", "en-US": "Built for 35kV grids, industrial parks and renewable step-up systems requiring stable supply." }
      },
      {
        title: { "zh-CN": "低损耗与低噪声", "en-US": "Low Loss and Low Noise" },
        description: { "zh-CN": "通过电磁设计、铁芯材料和工艺控制，兼顾运行效率与环境友好性。", "en-US": "Electromagnetic design, core materials and process control balance efficiency with environmental performance." }
      },
      {
        title: { "zh-CN": "抗短路可靠性", "en-US": "Short-Circuit Withstand Reliability" },
        description: { "zh-CN": "强化绕组支撑、绝缘结构与试验控制，提升故障冲击下的设备安全裕度。", "en-US": "Reinforced winding support, insulation and testing improve safety margin under fault impact." }
      }
    ]
  },
  "/products/110kv": {
    title: { "zh-CN": "箱式变电站", "en-US": "Prefabricated Substations" },
    intro: {
      "zh-CN": "提供箱式变电站、欧式箱变、美式箱变及新能源箱变等产品，适用于工商业园区、市政配电与工程快速落地场景。",
      "en-US": "Providing prefabricated substations, European-type substations, American-type substations and renewable energy substations for industrial parks, municipal distribution and fast project deployment."
    },
    galleryText: {
      "zh-CN": "箱式变电站将高压、变压器和低压单元集成在箱体内，适合工期紧、占地受限、现场安装条件复杂的项目。",
      "en-US": "Prefabricated substations integrate high-voltage, transformer and low-voltage units in one enclosure for compact and fast project deployment."
    },
    images: [],
    cards: [
      {
        title: { "zh-CN": "预装集成度高", "en-US": "Highly Prefabricated Integration" },
        description: { "zh-CN": "高压、变压器、低压配电单元工厂化集成，减少现场施工和调试周期。", "en-US": "Factory-integrated HV, transformer and LV units reduce on-site construction and commissioning time." }
      },
      {
        title: { "zh-CN": "占地小部署快", "en-US": "Compact and Fast Deployment" },
        description: { "zh-CN": "箱体结构紧凑，适合园区、市政、新能源和临电工程等空间受限场景。", "en-US": "Compact enclosure suits parks, municipal projects, renewable energy and temporary power sites." }
      },
      {
        title: { "zh-CN": "防护配置灵活", "en-US": "Flexible Protection Options" },
        description: { "zh-CN": "可按户外环境配置通风、温控、防护等级和外观方案，兼顾安全与运维。", "en-US": "Ventilation, temperature control, protection grade and exterior can be configured for outdoor operation." }
      }
    ]
  },
  "/products/500kv": {
    title: { "zh-CN": "高低压成套设备", "en-US": "High and Low Voltage Complete Sets" },
    intro: {
      "zh-CN": "配套生产高低压开关柜、配电箱、电抗器、消弧线圈等设备，可与变压器及箱变产品组成完整配电系统方案。",
      "en-US": "Supporting high and low voltage switchgear, distribution boxes, reactors and arc suppression coils, forming complete distribution system solutions with transformers and substations."
    },
    galleryText: {
      "zh-CN": "高低压成套设备用于电能分配、控制、保护和监测，可与变压器、箱变共同组成完整配电系统。",
      "en-US": "Complete switchgear sets support power distribution, control, protection and monitoring as part of integrated distribution systems."
    },
    images: [
      {
        slug: "gcd-low-voltage-switchgear",
        title: { "zh-CN": "GCD高低压成套开关设备", "en-US": "GCD High and Low Voltage Complete Switchgear" },
        src: "/products/switchgear/switchgear-01.jpg",
        summary: { "zh-CN": "低压配电成套设备，用于电能分配、控制、保护和计量。", "en-US": "Low-voltage complete set for power distribution, control, protection and metering." },
        description: { "zh-CN": "GCD高低压成套开关设备适用于交流低压配电系统，可承担馈电、控制、保护、计量等功能。柜体结构强调成套化和工程适配，适合工业厂房、建筑配电室和箱变低压侧配套。", "en-US": "GCD low-voltage switchgear is used in AC low-voltage distribution systems for feeding, control, protection and metering. Its complete-set cabinet structure suits plants, building distribution rooms and substation LV sides." },
        specs: [
          { "zh-CN": "型号特点：低压成套、配电控制", "en-US": "Model: LV complete set, distribution control" },
          { "zh-CN": "适用方向：厂房、楼宇、箱变低压侧", "en-US": "Use: plants, buildings, substation LV side" }
        ]
      },
      {
        slug: "gcs-low-voltage-withdrawable-switchgear",
        title: { "zh-CN": "GCS低压抽出式开关柜", "en-US": "GCS Low-Voltage Withdrawable Switchgear" },
        src: "/products/switchgear/switchgear-02.jpg",
        summary: { "zh-CN": "抽屉式结构便于回路维护和扩展，适合回路数量多的低压配电系统。", "en-US": "Withdrawable structure supports circuit maintenance and expansion in LV systems with many feeders." },
        description: { "zh-CN": "GCS低压抽出式开关柜采用功能单元抽屉化设计，便于检修、更换和分路管理。常用于发电、石化、冶金、建筑和工业配电等对供电连续性和维护效率要求较高的场合。", "en-US": "GCS low-voltage withdrawable switchgear uses drawer-type functional units for maintenance, replacement and feeder management, fitting power, petrochemical, metallurgy, building and industrial distribution." },
        specs: [
          { "zh-CN": "型号特点：抽屉式、回路管理清晰", "en-US": "Model: withdrawable, clear feeder management" },
          { "zh-CN": "适用方向：多回路低压配电、工业配电室", "en-US": "Use: multi-feeder LV distribution, industrial rooms" }
        ]
      },
      {
        slug: "kyn28a-12-metal-clad-switchgear",
        title: { "zh-CN": "KYN28A-12户内金属铠装中置式开关设备", "en-US": "KYN28A-12 Metal-Clad Switchgear" },
        src: "/products/switchgear/switchgear-03.jpg",
        summary: { "zh-CN": "12kV户内中压开关柜，适合变配电站进出线、保护和控制。", "en-US": "12kV indoor medium-voltage switchgear for substation incoming/outgoing feeders, protection and control." },
        description: { "zh-CN": "KYN28A-12为常见户内金属铠装中置式开关设备，常用于3.6kV至12kV配电系统。柜体分隔明确，可配置断路器手车、继电保护和联锁机构，服务于变电站、工矿企业和公共建筑配电。", "en-US": "KYN28A-12 is a common indoor metal-clad switchgear for 3.6kV to 12kV systems. It can use circuit-breaker trucks, relay protection and interlocks for substations, industrial users and public buildings." },
        specs: [
          { "zh-CN": "型号特点：12kV、金属铠装、中置式", "en-US": "Model: 12kV, metal-clad, mid-mounted" },
          { "zh-CN": "适用方向：变电站、工矿企业、中压配电", "en-US": "Use: substations, industrial users, MV distribution" }
        ]
      },
      {
        slug: "mns-low-voltage-switchgear",
        title: { "zh-CN": "MSN低压抽出式开关柜", "en-US": "MSN Low-Voltage Withdrawable Switchgear" },
        src: "/products/switchgear/switchgear-04.jpg",
        summary: { "zh-CN": "模块化低压柜型，适合需要灵活组合和可靠分配的低压系统。", "en-US": "Modular LV cabinet type for flexible configuration and reliable distribution." },
        description: { "zh-CN": "MSN低压抽出式开关柜以抽屉式功能单元和标准化柜架为特点，可按馈线、无功补偿、电机控制和配电回路进行灵活配置，适合大型建筑、工业厂房和能源项目。", "en-US": "MSN low-voltage withdrawable switchgear features drawer-type functional units and standardized frames for feeders, reactive compensation, motor control and distribution circuits in large buildings, plants and energy projects." },
        specs: [
          { "zh-CN": "型号特点：模块化、组合灵活", "en-US": "Model: modular, flexible configuration" },
          { "zh-CN": "适用方向：建筑配电、工业控制、能源项目", "en-US": "Use: building distribution, industrial control, energy projects" }
        ]
      },
      {
        slug: "xgn15-12-ring-main-unit",
        title: { "zh-CN": "XGN15-12交流金属封闭环网开关设备", "en-US": "XGN15-12 Ring Main Unit" },
        src: "/products/switchgear/switchgear-05.jpg",
        summary: { "zh-CN": "12kV环网柜方向产品，用于环网供电、终端配电和箱变高压侧。", "en-US": "12kV ring-main product for loop supply, terminal distribution and substation HV sides." },
        description: { "zh-CN": "XGN15-12交流金属封闭环网开关设备适用于12kV配电网络，常用于城市配网、箱式变电站、高层建筑和工业园区。设备强调结构紧凑、操作安全和环网供电适配。", "en-US": "XGN15-12 AC metal-enclosed ring main units serve 12kV distribution networks in urban grids, substations, high-rise buildings and industrial parks, emphasizing compactness, safe operation and loop-network fit." },
        specs: [
          { "zh-CN": "型号特点：12kV、金属封闭、环网供电", "en-US": "Model: 12kV, metal-enclosed, ring-main supply" },
          { "zh-CN": "适用方向：城市配网、箱变高压侧、终端配电", "en-US": "Use: urban grids, substation HV side, terminal distribution" }
        ]
      }
    ],
    cards: [
      {
        title: { "zh-CN": "控制保护完整", "en-US": "Complete Control and Protection" },
        description: { "zh-CN": "满足配电系统分合闸、计量、保护、监测等需求，提升系统运行安全性。", "en-US": "Supports switching, metering, protection and monitoring to improve distribution system safety." }
      },
      {
        title: { "zh-CN": "柜型覆盖丰富", "en-US": "Broad Cabinet Coverage" },
        description: { "zh-CN": "覆盖GCS、MSN、KYN、XGN等常用柜型，便于按高低压系统需求组合配置。", "en-US": "Covers common GCS, MSN, KYN and XGN cabinet types for HV and LV system configuration." }
      },
      {
        title: { "zh-CN": "系统配套效率高", "en-US": "Efficient System Matching" },
        description: { "zh-CN": "可与变压器、箱式变电站、电抗器等设备协同设计，减少多供应商协调成本。", "en-US": "Can be coordinated with transformers, substations and reactors to reduce multi-vendor coordination." }
      }
    ]
  },
  "/products/330-400kv": {
    title: { "zh-CN": "35kV电力变压器", "en-US": "35kV Power Transformers" },
    intro: {
      "zh-CN": "面向35kV电力系统应用，服务工业园区、区域配网、新能源升压站及工程配套项目。",
      "en-US": "Designed for 35kV power systems, serving industrial parks, regional distribution grids, renewable booster stations and engineering projects."
    },
    cards: [
      { "zh-CN": "35kV系统适配", "en-US": "35kV System Fit" },
      { "zh-CN": "工程配套能力", "en-US": "Engineering Support" },
      { "zh-CN": "可靠供电表现", "en-US": "Reliable Power Supply" }
    ]
  }
};

const detail = (slug, title, enTitle, src, summary, enSummary, description, enDescription, specs) => ({
  slug,
  title: { "zh-CN": title, "en-US": enTitle },
  src,
  summary: { "zh-CN": summary, "en-US": enSummary },
  description: { "zh-CN": description, "en-US": enDescription },
  specs
});

const categoryImageMap = {
  "/products/oil-immersed": [
    detail(
      "s11-oil-immersed-transformer",
      "S11型油浸式变压器",
      "S11 Oil-Immersed Transformer",
      "/products/oil-immersed/oil-immersed-01.jpg",
      "S11系列侧重低损耗与成熟可靠，适合常规配网和工程项目。",
      "S11 series focuses on low loss and mature reliability for distribution and engineering projects.",
      "S11型油浸式变压器通常采用低损耗硅钢片铁芯与强化绕组结构，相比早期型号在空载损耗、噪声和运行效率上更友好。适合需要稳定供电、维护周期明确、性价比均衡的配电工程。",
      "S11 oil-immersed transformers typically use low-loss silicon-steel cores and reinforced windings, improving no-load loss, noise and operating efficiency over earlier designs. They suit stable distribution projects requiring balanced cost and reliability.",
      [
        { "zh-CN": "型号特点：S11低损耗配电系列", "en-US": "Model: S11 low-loss distribution series" },
        { "zh-CN": "适用方向：工厂、居民区、一般配网工程", "en-US": "Use: factories, communities, general distribution projects" }
      ]
    ),
    detail(
      "s13-oil-immersed-transformer",
      "S13型油浸式变压器",
      "S13 Oil-Immersed Transformer",
      "/products/oil-immersed/oil-immersed-02.jpg",
      "S13系列进一步降低损耗，适合对能效和长期运行成本更敏感的项目。",
      "S13 series further reduces losses for projects sensitive to efficiency and long-term operating cost.",
      "S13型油浸式变压器以降低空载损耗和提升运行效率为主要方向，常用于配网改造、园区供电和节能型工程。对于全年通电时间长、负荷变化明显的场景，低损耗设计有助于降低长期电能消耗。",
      "S13 oil-immersed transformers emphasize reduced no-load loss and higher operating efficiency. They are commonly used in grid upgrades, park supply and energy-saving projects where long energization time makes loss reduction valuable.",
      [
        { "zh-CN": "型号特点：较S11更偏节能升级", "en-US": "Model: energy-saving upgrade over S11 direction" },
        { "zh-CN": "适用方向：配网改造、园区供电、节能项目", "en-US": "Use: grid upgrades, park supply, energy-saving projects" }
      ]
    ),
    detail(
      "s13-wound-core-oil-immersed-transformer",
      "S13立体卷铁芯油浸式变压器",
      "S13 Wound-Core Oil-Immersed Transformer",
      "/products/oil-immersed/oil-immersed-03.jpg",
      "立体卷铁芯结构有助于优化磁路，降低噪声和空载损耗。",
      "Wound-core construction helps optimize magnetic paths and reduce noise and no-load loss.",
      "S13立体卷铁芯油浸式变压器通过三相对称磁路和卷绕铁芯工艺提升磁路利用率，常用于对运行噪声、节能表现和外形紧凑性有要求的配电场合。",
      "S13 wound-core oil-immersed transformers use a symmetrical three-phase magnetic path and wound-core process to improve magnetic utilization, fitting distribution sites that value lower noise, energy saving and compactness.",
      [
        { "zh-CN": "型号特点：立体卷铁芯、磁路更均衡", "en-US": "Model: wound core with balanced magnetic path" },
        { "zh-CN": "适用方向：低噪声、节能型配电场景", "en-US": "Use: low-noise and energy-saving distribution" }
      ]
    ),
    detail(
      "sh15-amorphous-alloy-transformer",
      "SH15非晶合金变压器",
      "SH15 Amorphous Alloy Transformer",
      "/products/oil-immersed/oil-immersed-04.jpg",
      "SH15采用非晶合金铁芯，优势集中在超低空载损耗和节能运行。",
      "SH15 uses an amorphous alloy core, focusing on ultra-low no-load loss and energy-saving operation.",
      "SH15非晶合金变压器用非晶合金材料替代传统硅钢片铁芯，可显著降低铁芯损耗，尤其适合轻载、夜间负荷低或全年长时间带电的配电点。其价值主要体现在长期节能和降低运行成本。",
      "SH15 amorphous alloy transformers replace traditional silicon-steel cores with amorphous alloy material to significantly reduce core loss. They are well suited to light-load or continuously energized distribution points where long-term energy saving matters.",
      [
        { "zh-CN": "型号特点：非晶合金铁芯、空载损耗低", "en-US": "Model: amorphous alloy core, low no-load loss" },
        { "zh-CN": "适用方向：低负荷时段长、节能改造项目", "en-US": "Use: long light-load periods and energy-saving retrofits" }
      ]
    ),
    detail(
      "grade-1-oil-immersed-transformer",
      "能效一级油浸式变压器",
      "Grade-1 Energy-Efficient Oil-Immersed Transformer",
      "/products/oil-immersed/oil-immersed-05.jpg",
      "面向更高能效要求的配电项目，兼顾低损耗、稳定运行和长期电费优化。",
      "Built for higher-efficiency projects, balancing low loss, stable operation and lifecycle energy cost.",
      "能效一级油浸式变压器围绕更严格的损耗控制进行设计，适合新建节能项目、园区配电和长期运行成本敏感的场景。选型时通常结合容量、负载率、运行小时数和能效标准综合评估。",
      "Grade-1 energy-efficient oil-immersed transformers are designed around stricter loss control for new energy-saving projects, park distribution and sites sensitive to lifecycle operating cost.",
      [
        { "zh-CN": "型号特点：高能效、低运行损耗", "en-US": "Model: high efficiency, low operating loss" },
        { "zh-CN": "适用方向：新建园区、节能改造、长期运行场景", "en-US": "Use: new parks, energy retrofits, long-running sites" }
      ]
    ),
    detail(
      "grade-2-oil-immersed-transformer",
      "能效二级油浸式变压器",
      "Grade-2 Energy-Efficient Oil-Immersed Transformer",
      "/products/oil-immersed/oil-immersed-06.jpg",
      "兼顾能效与成本，适合常规节能型配电工程。",
      "Balances energy efficiency and cost for standard energy-saving distribution projects.",
      "能效二级油浸式变压器适合对损耗有明确要求，同时需要兼顾项目预算的配电工程。产品可按容量、负载率和运行小时数综合选择，满足多数园区和工商业配电需求。",
      "Grade-2 energy-efficient oil-immersed transformers suit projects requiring loss control while balancing budget, with selection based on capacity, load rate and operating hours.",
      [
        { "zh-CN": "型号特点：节能等级明确、性价比均衡", "en-US": "Model: clear efficiency grade, balanced cost" },
        { "zh-CN": "适用方向：工商业配电、园区供电、常规改造", "en-US": "Use: commercial distribution, park supply, standard retrofits" }
      ]
    )
  ],
  "/products/dry-type": [
    detail(
      "scb11-dry-type-transformer",
      "SC(B)11干式变压器",
      "SC(B)11 Dry-Type Transformer",
      "/products/dry-type/dry-type-01.jpg",
      "SC(B)11为常用环氧浇注干式系列，兼顾绝缘强度、低噪声和运行可靠性。",
      "SC(B)11 is a common cast-resin dry-type series balancing insulation strength, low noise and reliability.",
      "SC(B)11干式变压器通常采用环氧树脂浇注线圈，具备较好的防潮、防尘和机械强度表现，适合负荷稳定、安装空间位于建筑内部的配电系统。",
      "SC(B)11 dry-type transformers typically use epoxy cast-resin windings, offering moisture resistance, dust resistance and mechanical strength for indoor distribution systems.",
      [
        { "zh-CN": "型号特点：环氧浇注、绝缘稳定", "en-US": "Model: cast resin, stable insulation" },
        { "zh-CN": "适用方向：商业建筑、公共设施、工业室内配电", "en-US": "Use: commercial buildings, public facilities, indoor industrial distribution" }
      ]
    ),
    detail(
      "scb12-dry-type-transformer",
      "SC(B)12型干式变压器",
      "SC(B)12 Dry-Type Transformer",
      "/products/dry-type/dry-type-02.jpg",
      "SC(B)12在损耗、噪声和绝缘稳定性上进一步优化，适合节能型室内配电。",
      "SC(B)12 further optimizes loss, noise and insulation stability for energy-saving indoor distribution.",
      "SC(B)12型干式变压器属于节能型干式系列，可用于商业建筑、工矿企业、公共设施等室内配电场景，兼顾安全、环保和较低维护量。",
      "SC(B)12 dry-type transformers belong to an energy-saving dry-type series for commercial buildings, industrial users and public facilities, balancing safety, environmental performance and low maintenance.",
      [
        { "zh-CN": "型号特点：节能型干式系列", "en-US": "Model: energy-saving dry-type series" },
        { "zh-CN": "适用方向：室内配电、公共建筑、工业项目", "en-US": "Use: indoor distribution, public buildings, industrial projects" }
      ]
    ),
    detail(
      "scb12-wound-core-dry-type-transformer",
      "SC(B)12立体卷铁心干式变压器",
      "SC(B)12 Wound-Core Dry-Type Transformer",
      "/products/dry-type/dry-type-03.jpg",
      "立体卷铁心结构优化磁路，适合低损耗、低噪声和紧凑安装需求。",
      "Wound-core construction optimizes magnetic paths for low loss, low noise and compact installation.",
      "SC(B)12立体卷铁心干式变压器将干式绝缘结构与立体卷铁心磁路结合，能够改善三相磁路平衡，降低空载损耗和运行噪声，适合对能效和噪声更敏感的室内场景。",
      "SC(B)12 wound-core dry-type transformers combine dry insulation with a wound-core magnetic path, improving phase balance and reducing no-load loss and noise in indoor applications.",
      [
        { "zh-CN": "型号特点：立体卷铁心、低损耗", "en-US": "Model: wound core, low loss" },
        { "zh-CN": "适用方向：办公楼、医院、轨交、园区配电", "en-US": "Use: offices, hospitals, rail transit, park distribution" }
      ]
    ),
    detail(
      "scb13-dry-type-transformer",
      "SC(B)13型干式变压器",
      "SC(B)13 Dry-Type Transformer",
      "/products/dry-type/dry-type-04.jpg",
      "SC(B)13偏向节能升级，适合更关注损耗控制和长期运行成本的项目。",
      "SC(B)13 focuses on energy-saving upgrades for projects concerned with loss control and lifecycle cost.",
      "SC(B)13型干式变压器在损耗控制、绝缘系统和噪声表现上进一步优化，适合新建建筑配电、老旧设备替换和节能改造项目。",
      "SC(B)13 dry-type transformers further optimize loss control, insulation and noise performance, fitting new building distribution, equipment replacement and energy-saving retrofits.",
      [
        { "zh-CN": "型号特点：节能型干式系列", "en-US": "Model: energy-saving dry-type series" },
        { "zh-CN": "适用方向：节能改造、新建室内配电", "en-US": "Use: energy retrofits, new indoor distribution" }
      ]
    ),
    detail(
      "scb10-dry-type-power-transformer",
      "SC(B)10型干式电力变压器",
      "SC(B)10 Dry-Type Power Transformer",
      "/products/dry-type/dry-type-05.jpg",
      "SC(B)10为成熟干式电力变压器系列，适合常规室内配电和工程配套。",
      "SC(B)10 is a mature dry-type power transformer series for standard indoor distribution and projects.",
      "SC(B)10型干式电力变压器在工程应用中较为成熟，可满足一般室内配电对安全、可靠、维护便利的要求。适合预算明确、技术路线稳定的楼宇和工业配套项目。",
      "SC(B)10 dry-type power transformers are mature in engineering use and meet typical indoor distribution needs for safety, reliability and easy maintenance.",
      [
        { "zh-CN": "型号特点：成熟可靠、工程适配度高", "en-US": "Model: mature, reliable, project-friendly" },
        { "zh-CN": "适用方向：一般楼宇配电、工业厂房配电", "en-US": "Use: building distribution, industrial plant distribution" }
      ]
    ),
    detail(
      "scbh15-amorphous-alloy-dry-type-transformer",
      "SC(B)H15非晶合金干式变压器",
      "SC(B)H15 Amorphous Alloy Dry-Type Transformer",
      "/products/dry-type/dry-type-06.jpg",
      "非晶合金铁芯面向低损耗干式配电需求，适合长期带电和节能改造场景。",
      "Amorphous alloy core design supports low-loss dry-type distribution for long-energized and energy-saving scenarios.",
      "SC(B)H15非晶合金干式变压器围绕低损耗铁芯、无油化绝缘和节能运行进行设计，适用于对消防安全、环保和全寿命周期能耗都有要求的室内配电项目。",
      "SC(B)H15 amorphous alloy dry-type transformers are designed around low-loss cores, oil-free insulation and energy-saving operation for indoor distribution projects with safety, environmental and lifecycle energy requirements.",
      [
        { "zh-CN": "型号特点：非晶合金、低损耗、无油化", "en-US": "Model: amorphous alloy, low loss, oil-free" },
        { "zh-CN": "适用方向：节能改造、公共建筑、长期运行场景", "en-US": "Use: energy retrofits, public buildings, long-running sites" }
      ]
    ),
    detail(
      "sgb10-non-encapsulated-dry-type-transformer",
      "SG(B)10系列非包封干式变压器",
      "SG(B)10 Non-Encapsulated Dry-Type Transformer",
      "/products/dry-type/dry-type-07.jpg",
      "非包封结构散热条件好，适合通风条件明确的工业和建筑配电。",
      "Non-encapsulated construction supports good ventilation for industrial and building distribution.",
      "SG(B)10系列非包封干式变压器通常采用开放通风结构，具有散热直接、维护检查便利等特点，适合有良好安装环境和通风条件的室内配电场景。",
      "SG(B)10 non-encapsulated dry-type transformers typically use open ventilated construction, offering direct cooling and convenient inspection for indoor sites with proper ventilation.",
      [
        { "zh-CN": "型号特点：非包封、通风散热、维护便利", "en-US": "Model: non-encapsulated, ventilated, easy maintenance" },
        { "zh-CN": "适用方向：工业厂房、配电室、公共设施", "en-US": "Use: industrial plants, distribution rooms, public facilities" }
      ]
    ),
    detail(
      "sgb12-wound-core-non-encapsulated-dry-type-transformer",
      "SG(B)12(非包封)立体卷铁心干式变压器",
      "SG(B)12 Wound-Core Non-Encapsulated Dry-Type Transformer",
      "/products/dry-type/dry-type-08.jpg",
      "结合非包封散热与立体卷铁心磁路，兼顾低损耗和维护便利。",
      "Combines non-encapsulated cooling with wound-core magnetic paths for low loss and easy maintenance.",
      "SG(B)12(非包封)立体卷铁心干式变压器将通风散热结构与立体卷铁心设计结合，可降低空载损耗和噪声，同时方便后期检查维护，适合节能型室内配电系统。",
      "SG(B)12 wound-core non-encapsulated dry-type transformers combine ventilated cooling with wound-core design to reduce no-load loss and noise while supporting inspection and maintenance.",
      [
        { "zh-CN": "型号特点：非包封、立体卷铁心、低损耗", "en-US": "Model: non-encapsulated, wound core, low loss" },
        { "zh-CN": "适用方向：节能室内配电、工业建筑", "en-US": "Use: energy-saving indoor distribution, industrial buildings" }
      ]
    ),
    detail(
      "grade-1-dry-type-transformer",
      "能效一级干式变压器",
      "Grade-1 Energy-Efficient Dry-Type Transformer",
      "/products/dry-type/dry-type-09.jpg",
      "面向高能效标准的干式产品，适合长期运行和节能指标明确的项目。",
      "Dry-type product for higher efficiency standards and projects with clear energy-saving targets.",
      "能效一级干式变压器在铁芯材料、绕组工艺和温升控制上更重视损耗优化，适合数据中心、商业综合体、医院和园区等全年运行时间较长的场景。",
      "Grade-1 energy-efficient dry-type transformers place stronger emphasis on loss optimization in core material, winding process and temperature rise control, suiting data centers, malls, hospitals and parks.",
      [
        { "zh-CN": "型号特点：高能效、低损耗、低维护", "en-US": "Model: high efficiency, low loss, low maintenance" },
        { "zh-CN": "适用方向：数据中心、医院、商业综合体、园区", "en-US": "Use: data centers, hospitals, malls, parks" }
      ]
    ),
    detail(
      "grade-2-dry-type-transformer",
      "能效二级干式变压器",
      "Grade-2 Energy-Efficient Dry-Type Transformer",
      "/products/dry-type/dry-type-10.jpg",
      "兼顾能效要求和项目成本，适合常规节能型室内配电。",
      "Balances efficiency requirements and project cost for standard energy-saving indoor distribution.",
      "能效二级干式变压器适合对损耗指标有明确要求，同时需要控制预算的建筑和工业配电项目。相比普通产品，其重点在于降低运行损耗和提升全寿命周期经济性。",
      "Grade-2 energy-efficient dry-type transformers suit building and industrial distribution projects requiring loss control while managing budget, improving lifecycle economics over standard products.",
      [
        { "zh-CN": "型号特点：能效等级明确、低维护", "en-US": "Model: clear efficiency grade, low maintenance" },
        { "zh-CN": "适用方向：商业建筑、厂区、公共配电", "en-US": "Use: commercial buildings, plants, public distribution" }
      ]
    )
  ],
  "/products/220kv": [
    detail(
      "35kv-dry-type-transformer",
      "35KV级干式变压器",
      "35kV Dry-Type Transformer",
      "/products/35kv-power/35kv-power-01.jpg",
      "面向35kV中压系统的干式方案，适合防火要求高的升压和配电场景。",
      "Dry-type solution for 35kV medium-voltage systems where fire safety is important.",
      "35KV级干式变压器结合中压等级与无油化绝缘优势，适合新能源升压、工业园区、轨交和大型公共建筑等对电压等级、消防安全和室内安装同时有要求的项目。",
      "35kV dry-type transformers combine medium-voltage capability with oil-free insulation, fitting renewable step-up, industrial parks, rail transit and large public buildings.",
      [
        { "zh-CN": "型号特点：35kV等级、无油化绝缘", "en-US": "Model: 35kV class, oil-free insulation" },
        { "zh-CN": "适用方向：新能源升压、轨交、工业园区", "en-US": "Use: renewable step-up, rail transit, industrial parks" }
      ]
    ),
    detail(
      "35kv-power-transformer",
      "35kV级电力变压器",
      "35kV Power Transformer",
      "/products/35kv-power/35kv-power-02.jpg",
      "用于35kV配网、工业供电和升压站，强调绝缘可靠、低损耗与抗短路能力。",
      "Used in 35kV grids, industrial supply and step-up stations with reliable insulation and low loss.",
      "35kV级电力变压器通常承担区域配网、工矿企业、新能源升压站等关键节点的电压变换任务。产品选型重点关注短路承受能力、绝缘裕度、温升控制、损耗水平和长期运行可靠性。",
      "35kV power transformers handle voltage transformation in regional grids, industrial users and renewable step-up stations. Selection focuses on short-circuit withstand, insulation margin, temperature rise, loss level and reliability.",
      [
        { "zh-CN": "型号特点：35kV系统适配、运行稳定", "en-US": "Model: 35kV system fit, stable operation" },
        { "zh-CN": "适用方向：区域配网、工业供电、新能源升压", "en-US": "Use: regional grids, industrial supply, renewable step-up" }
      ]
    )
  ],
  "/products/110kv": [
    detail(
      "yb-pre-installed-substation",
      "YB预装式变电站",
      "YB Pre-Installed Substation",
      "/products/prefabricated-substation/prefabricated-substation-01.jpg",
      "工厂完成主要装配和测试，现场安装周期短、投运效率高。",
      "Factory-assembled and tested for short installation time and fast commissioning.",
      "YB预装式变电站把一次设备、二次控制、计量保护和箱体结构前置到工厂完成，现场主要进行基础、吊装、接线和调试。适合工期紧、现场施工条件有限的项目。",
      "YB pre-installed substations move primary equipment, secondary control, metering, protection and enclosure assembly into the factory, leaving mainly foundation, lifting, wiring and commissioning on site.",
      [
        { "zh-CN": "型号特点：预装预调、现场工作量少", "en-US": "Model: pre-assembled, pre-tested, less site work" },
        { "zh-CN": "适用方向：快交付项目、空间受限项目", "en-US": "Use: fast-delivery and space-limited projects" }
      ]
    ),
    detail(
      "zgs-combined-substation",
      "ZGS型组合式变电站",
      "ZGS Combined Substation",
      "/products/prefabricated-substation/prefabricated-substation-02.jpg",
      "ZGS组合式结构常见于美式箱变方向，体积紧凑、集成度高。",
      "ZGS combined construction is common in American-style compact substations with high integration.",
      "ZGS型组合式变电站通常将变压器、高压负荷开关、熔断保护和低压配电部分进行紧凑化组合，适合住宅小区、商业配套、道路照明和分散式供电点。",
      "ZGS combined substations typically compactly integrate transformer, HV load switch, fuse protection and LV distribution, fitting residential, commercial, road lighting and distributed supply points.",
      [
        { "zh-CN": "型号特点：组合式、紧凑型、高集成", "en-US": "Model: combined, compact, highly integrated" },
        { "zh-CN": "适用方向：小区、商业、市政分散供电", "en-US": "Use: residential, commercial and municipal distributed supply" }
      ]
    )
  ]
};

Object.keys(categoryImageMap).forEach((categoryPath) => {
  productPageMap[categoryPath].images = categoryImageMap[categoryPath];
});

export const productDetailMap = Object.keys(productPageMap).reduce((details, categoryPath) => {
  const category = productPageMap[categoryPath];
  (category.images || []).forEach((item) => {
    details[item.slug] = {
      ...item,
      categoryPath,
      categoryTitle: category.title
    };
  });
  return details;
}, {});

export function getProductDetailBySlug(slug) {
  return productDetailMap[slug] || null;
}

export const galleryItems = [
  { "zh-CN": "厂区外立面", "en-US": "Factory Exterior", image: "/gallery/factory-exterior.jpg" },
  { "zh-CN": "生产车间", "en-US": "Production Workshop", image: "/gallery/production-workshop.jpg" },
  { "zh-CN": "检测中心", "en-US": "Testing Center", image: "/gallery/testing-center.jpg" },
  { "zh-CN": "成套装配区", "en-US": "Assembly Area", image: "/gallery/assembly-area.jpg" },
  { "zh-CN": "试验大厅", "en-US": "Testing Hall", image: "/gallery/testing-hall.jpg" },
  { "zh-CN": "办公与展厅", "en-US": "Office and Exhibition Hall", image: "/gallery/office-showroom.jpg" }
];

export const caseItems = [
  {
    slug: "xuzhou-metro",
    title: { "zh-CN": "徐州地铁", "en-US": "Xuzhou Metro" },
    image: "/cases/xuzhou-metro.jpg",
    category: { "zh-CN": "轨道交通配电", "en-US": "Rail Transit Power" },
    summary: {
      "zh-CN": "城市轨道交通车站与区间系统负载密集，对供电连续性、消防安全和设备环境适应性要求高。",
      "en-US": "Urban rail transit has dense station and tunnel loads, requiring continuity, fire safety and environmental adaptability."
    },
    description: {
      "zh-CN": "徐州地铁承担城市公共交通骨干功能，车站内包含照明、通风空调、通信信号、电扶梯、安防和应急系统等多类负载。此类场景通常适合采用干式变压器、高低压成套设备与配电箱协同配置，在地下空间、潮湿环境和长时间运行条件下保持稳定供电，并兼顾检修通道、故障隔离和后期扩容。",
      "en-US": "Xuzhou Metro is a backbone of urban public transport, with lighting, HVAC, communication, escalator, security and emergency loads. Dry-type transformers, switchgear and distribution boxes can support stable underground power supply while considering maintenance access, fault isolation and future expansion."
    },
    points: [
      { "zh-CN": "地下空间强调无油化、阻燃、低维护和低噪声。", "en-US": "Underground spaces favor oil-free, fire-resistant, low-maintenance and low-noise equipment." },
      { "zh-CN": "车站负载类型复杂，需要清晰的分区供电与保护配置。", "en-US": "Complex station loads require clear zoning and protection design." },
      { "zh-CN": "适合围绕通风散热、应急供电和远期扩容做成套化方案。", "en-US": "A complete solution can be built around ventilation, emergency power and expansion." }
    ]
  },
  {
    slug: "state-grid",
    title: { "zh-CN": "国家电网", "en-US": "State Grid" },
    image: "/cases/state-grid.jpg",
    category: { "zh-CN": "电网基础设施", "en-US": "Grid Infrastructure" },
    summary: {
      "zh-CN": "面向配电网、园区供电和电力基础设施场景，重点关注低损耗、高可靠与连续运行能力。",
      "en-US": "For distribution grids, industrial parks and power infrastructure, the focus is low loss, reliability and continuous operation."
    },
    description: {
      "zh-CN": "国家电网相关基础设施覆盖范围广、运行标准高，配电侧设备通常需要应对负荷波动、长期带电、多级保护和运维可视化等要求。油浸式变压器、箱式变电站与高低压成套设备可围绕容量等级、进出线方式、场地条件和运维需求进行组合，支撑配网改造、园区供电、变电站低压侧配套等应用场景。",
      "en-US": "State Grid-related infrastructure has broad coverage and high operating standards. Distribution equipment must handle load variation, long energized hours, layered protection and maintainability. Oil-immersed transformers, prefabricated substations and switchgear can support grid upgrades, industrial park supply and substation-side matching."
    },
    points: [
      { "zh-CN": "配电连续性要求高，适合低损耗、高可靠设备组合。", "en-US": "High continuity requirements call for low-loss and reliable equipment." },
      { "zh-CN": "可覆盖配网改造、园区供电、变电站配套等场景。", "en-US": "Suitable for grid upgrades, park power supply and substation matching." },
      { "zh-CN": "方案需兼顾容量、保护、进出线方式与运维便利性。", "en-US": "Plans should balance capacity, protection, wiring and maintenance convenience." }
    ]
  },
  {
    slug: "xuzhou-joyland",
    title: { "zh-CN": "徐州乐园", "en-US": "Xuzhou Joyland" },
    image: "/cases/xuzhou-joyland.jpg",
    category: { "zh-CN": "文旅综合体", "en-US": "Cultural Tourism Complex" },
    summary: {
      "zh-CN": "主题乐园包含游乐设备、照明演艺、商业餐饮与公共服务负载，对安全供电和分区管理要求突出。",
      "en-US": "A theme park combines rides, show lighting, retail, dining and public-service loads, making safe power and zoning essential."
    },
    description: {
      "zh-CN": "徐州乐园属于大型文旅休闲场景，用电负载既包含游客服务区、商业餐饮和景观照明，也包含游乐设备、演艺系统及安防监控等关键系统。配电方案需要适应节假日高峰负荷、室外设备环境、分区停送电和应急保障需求。箱式变电站、高低压成套设备及配电箱可按园区功能片区进行布点，提升现场安装效率与后期运维清晰度。",
      "en-US": "Xuzhou Joyland represents a large cultural-tourism destination with visitor services, retail, dining, landscape lighting, rides, show systems and security loads. Distribution plans need to handle peak holidays, outdoor equipment, zoned switching and emergency requirements through substations, switchgear and distribution boxes."
    },
    points: [
      { "zh-CN": "室外场景重视防护等级、耐候性与安全隔离。", "en-US": "Outdoor scenarios value protection rating, weather resistance and safety isolation." },
      { "zh-CN": "客流高峰负载变化明显，需要预留容量与分区调度能力。", "en-US": "Peak visitor loads require reserve capacity and zoned dispatching." },
      { "zh-CN": "箱变布点有助于缩短低压供电半径并提升维护效率。", "en-US": "Substation placement can shorten LV supply distance and improve maintenance." }
    ]
  },
  {
    slug: "xuzhou-suning-plaza",
    title: { "zh-CN": "徐州市苏宁广场", "en-US": "Xuzhou Suning Plaza" },
    image: "/cases/xuzhou-suning-plaza.jpg",
    category: { "zh-CN": "商业综合体", "en-US": "Commercial Complex" },
    summary: {
      "zh-CN": "高层商业综合体业态复杂、负载密度高，要求楼宇配电稳定、分区清晰并便于运维。",
      "en-US": "High-rise commercial complexes have mixed functions and dense loads, requiring stable, zoned and maintainable power distribution."
    },
    description: {
      "zh-CN": "徐州市苏宁广场是城市商业地标类场景，通常集商业、办公、餐饮、停车和设备机房于一体，长时间运行且负载类型多。配电系统需要兼顾能效、保护选择性、噪声控制、机房空间和后续业态调整。干式变压器、高低压开关柜与配电箱可配合形成分区清晰的楼宇配电系统，服务商业运营的稳定性和管理效率。",
      "en-US": "Xuzhou Suning Plaza is a landmark commercial scenario combining retail, office, dining, parking and equipment rooms. Distribution systems must balance efficiency, protection selectivity, noise, machine-room space and tenant changes through dry-type transformers, switchgear and distribution boxes."
    },
    points: [
      { "zh-CN": "商业、办公与公共区域并存，回路划分要清晰。", "en-US": "Retail, office and public areas need clear circuit zoning." },
      { "zh-CN": "高层楼宇机房强调低噪声、低损耗和紧凑布置。", "en-US": "High-rise machine rooms value low noise, low loss and compact layout." },
      { "zh-CN": "保护与计量配置影响后续运营管理效率。", "en-US": "Protection and metering affect long-term operation management." }
    ]
  },
  {
    slug: "xuzhou-east-station",
    title: { "zh-CN": "京沪高铁徐州东站", "en-US": "Xuzhou East Railway Station" },
    image: "/cases/xuzhou-east-station.jpg",
    category: { "zh-CN": "交通枢纽", "en-US": "Transport Hub" },
    summary: {
      "zh-CN": "高铁站房客流密集、系统负载等级高，需要安全可靠的建筑配电和应急保障能力。",
      "en-US": "High-speed rail hubs have dense passenger flow and high-priority loads, requiring safe building distribution and emergency support."
    },
    description: {
      "zh-CN": "京沪高铁徐州东站承担高速铁路客运枢纽功能，站房内照明、暖通、电梯、通信、安防、商业配套和应急系统对供电稳定性要求较高。交通枢纽项目通常关注设备安全冗余、应急切换、消防要求、噪声控制和机房空间利用。干式变压器和高低压成套设备适合此类室内配电与公共建筑供电场景。",
      "en-US": "Xuzhou East Railway Station serves as a high-speed rail passenger hub. Lighting, HVAC, elevators, communication, security, retail support and emergency systems require stable power. Dry-type transformers and switchgear suit indoor distribution and public-building supply scenarios."
    },
    points: [
      { "zh-CN": "公共建筑消防安全要求高，干式变压器适配性强。", "en-US": "Public-building fire safety favors dry-type transformer solutions." },
      { "zh-CN": "交通枢纽负载连续性要求高，需要完善的保护与切换。", "en-US": "Transport hubs need strong protection and switching for continuity." },
      { "zh-CN": "设备布置需兼顾空间、检修和运行噪声。", "en-US": "Equipment layout must consider space, maintenance and operating noise." }
    ]
  },
  {
    slug: "cumt-science-park",
    title: { "zh-CN": "中矿大科技园", "en-US": "CUMT Science Park" },
    image: "/cases/cumt-science-park.jpg",
    category: { "zh-CN": "科创园区", "en-US": "Science Park" },
    summary: {
      "zh-CN": "科创园区兼具研发办公、试验平台和企业孵化空间，用电场景多样且扩展性要求高。",
      "en-US": "Science parks combine R&D offices, testing platforms and incubator spaces, requiring diverse and expandable power supply."
    },
    description: {
      "zh-CN": "中矿大科技园类园区通常包含研发办公、实验室、试制平台、展示和公共服务空间，负载弹性和后续扩容需求较明显。配电系统需要具备良好的分区能力、容量预留、设备兼容性和运维便利性。可根据园区分期建设与企业入驻变化，组合变压器、箱变和成套开关设备，形成可扩展的园区配电基础。",
      "en-US": "CUMT Science Park-type campuses include R&D offices, labs, pilot platforms, display and public-service spaces. They need zoning, reserve capacity, compatibility and maintainability through transformers, substations and switchgear."
    },
    points: [
      { "zh-CN": "园区负载增长不确定，需要容量预留和模块化设计。", "en-US": "Uncertain park load growth requires reserve capacity and modular design." },
      { "zh-CN": "研发与办公并存，设备组合要稳定且易维护。", "en-US": "R&D and office use need stable and maintainable equipment." },
      { "zh-CN": "分期建设适合可扩展的成套配电方案。", "en-US": "Phased construction suits expandable complete distribution plans." }
    ]
  },
  {
    slug: "xuzhou-olympic-center",
    title: { "zh-CN": "徐州市奥体中心", "en-US": "Xuzhou Olympic Sports Center" },
    image: "/cases/xuzhou-olympic-center.jpg",
    category: { "zh-CN": "文体场馆", "en-US": "Sports Venue" },
    summary: {
      "zh-CN": "大型体育场馆存在照明、空调、屏显、安防和赛事保障负载，对临场稳定性要求高。",
      "en-US": "Large sports venues include lighting, HVAC, displays, security and event loads that require high stability."
    },
    description: {
      "zh-CN": "徐州市奥体中心是大型公共文体场馆场景，赛事、演出和公共活动期间会出现阶段性高负载，对供电连续性、低压分配、应急供电和设备可靠性提出较高要求。成套开关设备、干式变压器和箱式变电站可结合场馆分区供电需求，形成清晰、可靠、便于维护的配电架构。",
      "en-US": "Xuzhou Olympic Sports Center represents a major public sports venue. Events and performances can create staged high loads, requiring continuity, LV distribution, emergency power and reliable equipment through switchgear, dry-type transformers and substations."
    },
    points: [
      { "zh-CN": "赛事照明和屏显负载集中，要求供电稳定。", "en-US": "Event lighting and displays require stable power." },
      { "zh-CN": "分区配电有助于降低故障影响范围。", "en-US": "Zoned distribution reduces fault impact scope." },
      { "zh-CN": "公共安全、应急保障和运维效率需要同步考虑。", "en-US": "Public safety, emergency support and maintenance efficiency matter together." }
    ]
  },
  {
    slug: "xuzhou-administrative-center",
    title: { "zh-CN": "徐州市行政中心", "en-US": "Xuzhou Administrative Center" },
    image: "/cases/xuzhou-administrative-center.jpg",
    category: { "zh-CN": "政务办公", "en-US": "Government Office" },
    summary: {
      "zh-CN": "政务办公建筑强调稳定办公、数据设备、公共服务窗口和安全系统的持续供电。",
      "en-US": "Government office buildings require stable power for office work, data equipment, service functions and safety systems."
    },
    description: {
      "zh-CN": "徐州市行政中心类政务办公建筑通常承载办公信息化、会议系统、安防监控、照明空调和公共服务配套，对用电安全、设备噪声、机房空间和长期运维便利性较为敏感。干式变压器与高低压成套设备可支撑室内配电，帮助形成可靠、清晰、便于管理的楼宇供电基础。",
      "en-US": "Xuzhou Administrative Center-type government office buildings include office IT, meeting systems, security monitoring, lighting, HVAC and public-service support. Dry-type transformers and switchgear can support safe, clear and maintainable building power distribution."
    },
    points: [
      { "zh-CN": "办公信息化系统需要稳定、清晰的配电回路。", "en-US": "Office IT systems need stable and clear distribution circuits." },
      { "zh-CN": "室内机房适合低噪声、低维护设备。", "en-US": "Indoor machine rooms benefit from low-noise, low-maintenance equipment." },
      { "zh-CN": "保护与计量配置便于日常管理和故障定位。", "en-US": "Protection and metering help daily management and fault location." }
    ]
  }
];

export const caseDetailMap = caseItems.reduce((details, item) => {
  details[item.slug] = item;
  return details;
}, {});

export function getCaseBySlug(slug) {
  return caseDetailMap[slug] || null;
}
